import { commentsHistoryConfig } from '@/lib/analytics/charts/facebook/commentsHistory';
import { followersHistoryConfig } from '@/lib/analytics/charts/facebook/followersHistory';
import { gainedLostFollowersConfig } from '@/lib/analytics/charts/facebook/gainedLostFollowers';
import { reactionsHistoryConfig } from '@/lib/analytics/charts/facebook/reactionsHistory';
import { avgEngagementRateFollowersPostConfig } from '@/lib/analytics/kpis/facebook/avgEngagementRateFollowersPost';
import { commentsConfig } from '@/lib/analytics/kpis/facebook/comments';
import { followersConfig } from '@/lib/analytics/kpis/facebook/followers';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/facebook/followersEvolution';
import { gainedFollowersConfig } from '@/lib/analytics/kpis/facebook/gainedFollowers';
import { lostFollowersConfig } from '@/lib/analytics/kpis/facebook/lostFollowers';
import { postsConfig } from '@/lib/analytics/kpis/facebook/posts';
import { reachConfig } from '@/lib/analytics/kpis/facebook/reach';
import { reactionsConfig } from '@/lib/analytics/kpis/facebook/reactions';
import { sharesConfig } from '@/lib/analytics/kpis/facebook/shares';
import { totalViewsConfig } from '@/lib/analytics/kpis/facebook/totalViews';
import { mostRecentPostsConfig } from '@/lib/analytics/widget/facebook/mostRecentPostsConfig';
import { SIZE_33 } from '@/lib/gridElements/size';

export const OverviewFacebook = [
    // Line 1
    followersConfig,
    followersEvolutionConfig,
    gainedFollowersConfig,
    lostFollowersConfig,

    // Line 2
    { ...totalViewsConfig, size: SIZE_33 },
    { ...reachConfig, size: SIZE_33 },
    { ...avgEngagementRateFollowersPostConfig, size: SIZE_33 },

    // Line 3
    followersHistoryConfig,
    gainedLostFollowersConfig,

    // Line 4
    reactionsHistoryConfig,
    commentsHistoryConfig,

    // Line 5
    mostRecentPostsConfig,

    // Line 6
    postsConfig,
    reactionsConfig,
    commentsConfig,
    sharesConfig
];

export const requestFacebookParams = [
    // FacebookPageMetrics
    [
        'followers',
        'followers_evolution',
        'gained_followers',
        'lost_followers',
        'total_views',
        'reach',
        'engagement',
        'average_engagement_rate_followers_per_post',
        'followers_history',
        'gained_lost_followers_history',
        'reactions_history',
        'comments_history'
    ],
    // FacebookMedia | FacebookPageMetrics
    [
        'posts',
        'reactions',
        'comments',
        'shares',
        'engagement_history',
        'reach_history',
        'reach_rate'
    ]
];
